import React,{useState, useEffect} from 'react'
import { getAllCompanyDetails,updateCompanyDetailsById ,deleteCompanyDetailsById ,companyDetailsDataInput} from "./../../../services/global_redux/globale_actions/CompanyDetails.action"

import { useDispatch} from "react-redux";

function AllCompanyDetails({ showSnackbar, setLoading }) {
    const dispatch = useDispatch();
    const [getCompanyDetails ,setCompanyDetails ]= useState([])

    const fetchCompanyDetails = async () =>{
        setLoading(true)
        try{
            const getCompanyData = await dispatch(getAllCompanyDetails());
            if(getCompanyData.success === true){
                setCompanyDetails(getCompanyData.data)
                setLoading(false)
            }else{
                setLoading(false);
                showSnackbar('something went wrong', "warning")
            }

        }catch(error){
            setLoading(false)
            console.error("Failed to fetch states:", error);
        }
    }
    useEffect(() => {
        fetchCompanyDetails();
    }, [dispatch]);
  return (
    <div  className="container-fluid windown-min-height" >
        <div className="col-md-12 py-3">
            <div className="card m-3 shadow">
                <div className="card-header card-header-color py-2 bg-light">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                        <h6 className="text-dark mb-0">Company Details</h6>
                        </div>
                        <div className="col-md-6 text-end">
                            <a href="/dashboard" className="text-dark">
                                <i className="bi bi-x fs-4 cancel-icon"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="card-body">

                    <div className="row">
                        <div className="col-md-12">
                            <div className="col-md-4">
                                <a className="btn btn-primary btn-sm" href='/company-details/new-company-details'>
                                    Add New Company Details
                                </a>
                            </div>
                        </div>
                        <div className="col-md-12 mt-4">
                            <div className="table-responsive">
                                <table className="table-bordered table-hover table rounded">
                                    <thead>
                                        <tr>
                                            <th>SL NO</th>
                                            <th>Company Code</th>
                                            <th>Company name</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getCompanyDetails?.map((data, index) => {
                                            return (
                                            <tr key={index + 1}>
                                                <td>{index + 1}</td>
                                                <th>{data.company_code}</th>
                                                <th><a href="">{data.company_name}</a></th>
                                                <th>{data.status === 1 ? "Active" : "In-active" }</th>
                                                <th><a href={`/company-details/update/${data.company_code}`}>view All Details/Update</a></th>
                                            </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AllCompanyDetails
